export default function IconConfirm({color = "white", size = 24}) {
    return (
        <svg
            width={size + 1}
            height={size}
            viewBox="0 0 16 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12.75 15.75H5.25C4.42157 15.75 3.75 15.0784 3.75 14.25V3.75C3.75 2.92157 4.42157 2.25 5.25 2.25H9.43934C9.63825 2.25 9.82902 2.32902 9.96967 2.46967L14.0303 6.53033C14.171 6.67098 14.25 6.86175 14.25 7.06066V8.625M6.75 9H11.25M6.75 12H9.96967"
                stroke={color} strokeWidth="2" strokeLinecap="round"
                strokeLinejoin="round"/>
            <path d="M12 12L13.5 13.5L16.5 10.5" stroke={color} strokeWidth="2" strokeLinecap="round"
                  strokeLinejoin="round"/>
        </svg>
    )
}
